export default "__VITE_ASSET__Db6K4N6S__"